const BORDER_RADIUS_MAP = {
  none: '0px',
  small: '4px',
  medium: '8px',
  large: '16px',
};

export function applyGalleryTheme(theme) {
  if (!theme) return;

  const root = document.documentElement;

  if (theme.color_primary) {
    root.style.setProperty('--primary-color', theme.color_primary);
    root.style.setProperty('--primary-color-hover', theme.color_primary);
  }
  if (theme.color_secondary) {
    root.style.setProperty('--secondary-color', theme.color_secondary);
  }
  if (theme.color_background) {
    root.style.setProperty('--background-color', theme.color_background);
  }
  if (theme.font_heading) {
    root.style.setProperty('--font-primary', `'${theme.font_heading}', sans-serif`);
  }
  if (theme.font_body) {
    root.style.setProperty('--font-secondary', `'${theme.font_body}', sans-serif`);
  }
  if (theme.border_radius) {
    root.style.setProperty('--border-radius', BORDER_RADIUS_MAP[theme.border_radius] || '10px');
  }
}
